import React from 'react'
import Logo from '../Logo/Logo'
import Title from '../Title/Title'

function Header() {
  return (
    <header >
      <Logo />
      <Title />
    </header>
  )
}

export default Header